import type { ReactNode } from 'react';
import { useState } from 'react';

import type { ApiOrgId } from 'api/types/ApiTypedId';
import {
  orgDashboardApiHideListing,
  orgDashboardApiUnhideListing,
} from 'modules/orgDashboard/api/listing/orgDashboardApiListing';
import type { OrgDashboardApiListing } from 'modules/orgDashboard/api/listing/types/OrgDashboardApiListing';
import { pushFlashMessage } from 'zustand-stores/flashMessagesStore';

type Props<TListing extends OrgDashboardApiListing = OrgDashboardApiListing> = {
  listingId: string;
  listingType: TListing['type'];
  orgId: ApiOrgId;
  render: (fn: {
    hideListing: () => Promise<TListing>;
    unhideListing: () => Promise<TListing>;
    submitting: boolean;
  }) => ReactNode;
};

export function OrgDashboardHideListingContainer<
  TListing extends OrgDashboardApiListing = OrgDashboardApiListing,
>({ listingId, listingType, orgId, render }: Props<TListing>) {
  const [submitting, setSubmitting] = useState(false);

  const toggleListingHidden = async (hide: boolean) => {
    setSubmitting(true);

    const toggle = hide
      ? orgDashboardApiHideListing
      : orgDashboardApiUnhideListing;

    const listing = await toggle({
      orgId,
      listingId,
      listingType,
    });

    setSubmitting(false);
    pushFlashMessage({ type: hide ? 'LISTING_HIDDEN' : 'LISTING_UNHIDDEN' });

    return listing;
  };

  const hideListing = () => toggleListingHidden(true);

  const unhideListing = () => toggleListingHidden(false);

  return <>{render({ hideListing, unhideListing, submitting })}</>;
}
